module.exports = __webpack_public_path__ + "img/home.c91c851a.png";